<template>
  <iframe id="fittingFrame" width="100%" height="100%" :src="site"></iframe>
</template>
<script>
import "@/delivery_widget.js";

export default {
  data() {
    return { site: "", selector: "" };
  },
  menu: {
    how_it_works: "/checkout#how_it_works",
    advantages: "/checkout#advantages",
    tariffs: "/checkout#tariffs"
  },
  watch: {
    "$route.params.site": function(site) {
      console.log(site);
      console.log(this.$route);
      window.document.getElementById("fittingFrame").src = "/proxy/" + site;
    }
  },
  mounted() {
    var iframe = window.document.getElementById("fittingFrame");
    var self = this;
    console.log(self.$route.query.selector);
    iframe.onload = function() {
      var elem = iframe.contentWindow.document.querySelector(
        self.$route.query.selector
      );
      if (elem) {
        var xpDiv = iframe.contentWindow.document.createElement("div");
        elem.appendChild(xpDiv);

        /* eslint no-undef: 0 */
        ExtraPost.init({
          token: "43a8cTFp2ekHzDIIw5K176Sc1q3bhPmAqPx0QXbZJGZ",
          from: "443961",
          window: iframe.contentWindow,
          document: iframe.contentWindow.document,
          target: xpDiv,
          weight: 1250,
          carriers: ["RussianPost", "CDEK", "DPD"]
        });
      }
    };

    console.log(this.$route.params.site);
    iframe.src = "/proxy/" + this.$route.params.site;
  }
};
</script>
